
import { defineComponent } from "vue";
import SamplingPointStationListComponent from "@/components/samplingPointStation/SamplingPointStationList.component.vue";

export default defineComponent({
  components: { SamplingPointStationListComponent },
  data() {
    return {};
  },
  methods: {},
});
